module.exports = __webpack_public_path__ + "img/Audit.a3fbd3e9.svg";